import Vue from "vue";
import App from "./App.vue";

Vue.config.productionTip = false;

new Vue({
  render(h) {
    const el = this.$el as HTMLElement;
    const data = { ...el.dataset };

    return h(App, {
      props: {
        options: data
      }
    });
  }
}).$mount("#ImageResizeApp");
